const LoginAsHelper = {
  revertIdentity() {
    const form = document.createElement("form");
    form.method = "post";
    form.action = "/identity/revert";
    form.style.display = "none";
    document.body.appendChild(form);
    form.submit();
  },
};

export default LoginAsHelper;
